const overviewRoute = {
  path: '/overview',
  name: 'overview',
  component: () => import('@/views/overview/overview'),
  meta: {hidden: true}
}
export default overviewRoute



// WEBPACK FOOTER //
// ./src/router/modules/overview.js